/**
 * Behavior for event sign up button
 *
 * Sign up button is a link to webform that we want to duplicate in event details
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccBreadcrumbs = {
    attach(context, settings) {
      once('rmccBreadcrumbsBehavior', '.breadcrumb .has-menu', context).forEach((elem) => {
        $(elem).on('click', function(e) {
          $('.breadcrumb-menu').toggle(300);
          $('.breadcrumb').toggleClass('open');
        });
      });
    }
  };
}) (Drupal, jQuery, once);